import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { createLocation } from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
import PopupCard from "../../../../Auth/PopupCard";
import axios from "axios";

const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Côte d’Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

const countryToCode = {
  Afghanistan: "AF",
  Albania: "AL",
  Algeria: "DZ",
  Andorra: "AD",
  Angola: "AO",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bhutan: "BT",
  Bolivia: "BO",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  Brazil: "BR",
  Brunei: "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  "Cabo Verde": "CV",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  "Central African Republic": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  Colombia: "CO",
  Comoros: "KM",
  Congo: "CG",
  "Costa Rica": "CR",
  "Côte d’Ivoire": "CI",
  Croatia: "HR",
  Cuba: "CU",
  Cyprus: "CY",
  "Czech Republic": "CZ",
  "Democratic Republic of the Congo": "CD",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  Ecuador: "EC",
  Egypt: "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Eswatini: "SZ",
  Ethiopia: "ET",
  Fiji: "FJ",
  Finland: "FI",
  France: "FR",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Greece: "GR",
  Grenada: "GD",
  Guatemala: "GT",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haiti: "HT",
  Honduras: "HN",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Ireland: "IE",
  Israel: "IL",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  "Marshall Islands": "MH",
  Mauritania: "MR",
  Mauritius: "MU",
  Mexico: "MX",
  Micronesia: "FM",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  "North Korea": "KP",
  "North Macedonia": "MK",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  Panama: "PA",
  "Papua New Guinea": "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippines: "PH",
  Poland: "PL",
  Portugal: "PT",
  Qatar: "QA",
  Romania: "RO",
  Russia: "RU",
  Rwanda: "RW",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Vincent and the Grenadines": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Korea": "KR",
  "South Sudan": "SS",
  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  Sweden: "SE",
  Switzerland: "CH",
  Syria: "SY",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  "Timor-Leste": "TL",
  Togo: "TG",
  Tonga: "TO",
  "Trinidad and Tobago": "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  Tuvalu: "TV",
  Uganda: "UG",
  Ukraine: "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United States": "US",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  "Vatican City": "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",
};

const AddLocation = ({ onOpen, onClose }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    location_type: "",
    other_type: "",
    country: "",
    countryCode: "",
    state: "",
    stateCode: "",
    city: "",
    address: "",
    status: "Active",
  });
  const [successPopup, setSuccessPopup] = useState({
    visible: false,
    type: "success",
    title: "Success",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [statesList, setStatesList] = useState([]);
  const [cities, setCities] = useState([]);

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    const countryCode = countryToCode[selectedCountry] || "";

    setFormData((prev) => ({
      ...prev,
      country: selectedCountry,
      countryCode: countryCode,
      state: "",
      stateCode: "",
      city: "",
    }));

    setErrors((prev) => ({
      ...prev,
      country: "",
      state: "",
      city: "",
    }));

    if (countryCode) {
      fetchStates(countryCode);
    } else {
      setStatesList([]);
    }
    setCities([]);
  };

  //GET STATES
  const fetchStates = async (countryCode) => {
    try {
      if (!countryCode) {
        setStatesList([]);
        return;
      }

      const res = await axios.get(
        `https://api.countrystatecity.in/v1/countries/${countryCode}/states`,
        {
          headers: {
            "X-CSCAPI-KEY":
              "0ae5a8283890022255b0058d88f4397ecde12b3253eae7c2af2ef157c23f108b",
          },
        },
      );

      setStatesList(res.data);
    } catch (err) {
      console.error("State fetch failed", err);
      setStatesList([]);
    }
  };

  //GET CITIES
  const fetchCities = async (countryCode, stateCode) => {
    try {
      if (!countryCode || !stateCode) {
        setCities([]);
        return;
      }

      const res = await axios.get(
        `https://api.countrystatecity.in/v1/countries/${countryCode}/states/${stateCode}/cities`,
        {
          headers: {
            "X-CSCAPI-KEY":
              "0ae5a8283890022255b0058d88f4397ecde12b3253eae7c2af2ef157c23f108b",
          },
        },
      );

      setCities(res.data);
    } catch (err) {
      console.error("City fetch failed", err);
      setCities([]);
    }
  };
  // validation
  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Location name is required";

    if (!formData.location_type) {
      newErrors.location_type = "Location type is required";
    } else if (
      formData.location_type === "Other" &&
      !formData.other_type.trim()
    ) {
      newErrors.other_type = "Please specify the location type";
    }

    if (!formData.country.trim()) newErrors.country = "Country is required";

    if (!formData.state.trim()) newErrors.state = "State is required";

    if (!formData.city.trim()) newErrors.city = "City is required";

    // if (!formData.address.trim()) newErrors.address = "Address is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // save function

  const handleSave = async () => {
    if (!validate()) return;

    try {
      const typeToSave =
        formData.location_type === "Other"
          ? formData.other_type
          : formData.location_type;
      const payload = {
        ...formData,
        location_type: typeToSave,
      };
      const res = await dispatch(
        createLocation({ formData: payload }),
      ).unwrap();

      setSuccessPopup({
        visible: true,
        type: "success",
        title: "Success",
        message: res.message,
      });

      setTimeout(() => {
        setSuccessPopup({ visible: false, message: "" });
        onClose();
      }, 3000);
    } catch (err) {
      console.error(err);
      setSuccessPopup({
        visible: true,
        type: "error",
        title: "Error",
        message:
          typeof err === "string"
            ? err
            : err?.message || "Something went wrong while adding location.",
      });
      setTimeout(() => {
        setSuccessPopup({
          visible: false,
          message: "",
          type: "success",
          title: "Success",
        });
      }, 3000);
    }
  };

  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Location Name */}
            <div>
              <label className="text-sm text-[#06513D]">Location Name</label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              />
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">{errors.name}</p>
              )}
            </div>

            {/* Location Type */}
            <div>
              <label className="text-sm text-[#06513D]">Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>

            {/* Country */}
            <div>
              <label className="text-sm text-[#06513D]">Country</label>
              <select
                name="country"
                value={formData.country}
                onChange={handleCountryChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="">Select Country</option>
                {countries.map((country) => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </select>
              {errors.country && (
                <p className="text-red-500 text-xs mt-1">{errors.country}</p>
              )}
            </div>

            {/* State */}
            <div>
              <label className="text-sm text-[#06513D]">State/Province</label>
              <select
                name="state"
                value={formData.stateCode}
                onChange={(e) => {
                  const selectedStateCode = e.target.value;
                  const selectedState = statesList.find(
                    (s) => s.iso2 === selectedStateCode,
                  );

                  setFormData((prev) => ({
                    ...prev,
                    state: selectedState?.name || "", // store name
                    stateCode: selectedStateCode, // store code
                    city: "",
                  }));

                  setErrors((prev) => ({
                    ...prev,
                    state: "",
                    city: "",
                  }));

                  fetchCities(formData.countryCode, selectedStateCode);
                }}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
                disabled={!formData.countryCode}
              >
                <option value="">Select State</option>
                {statesList.map((state) => (
                  <option key={state.id || state.iso2} value={state.iso2}>
                    {state.name}
                  </option>
                ))}
              </select>
              {errors.state && (
                <p className="text-red-500 text-xs mt-1">{errors.state}</p>
              )}
            </div>

            {/* City */}
            <div>
              <label className="text-sm text-[#06513D]">City</label>
              <select
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
                disabled={!formData.stateCode}
              >
                <option value="">Select City</option>
                {cities.map((city, index) => (
                  <option key={index} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
              {errors.city && (
                <p className="text-red-500 text-xs mt-1">{errors.city}</p>
              )}
            </div>

            {/* Address */}
            <div>
              <label className="text-sm text-[#06513D]">Address</label>
              <input
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              />
              {errors.address && (
                <p className="text-red-500 text-xs mt-1">{errors.address}</p>
              )}
            </div>

            <div>
              <label className="text-sm text-[#06513D]">Location Type</label>
              <select
                name="location_type"
                value={formData.location_type}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="">Select Type</option>
                <option value="Corporate Office">Corporate Office</option>
                <option value="Manufacturing Plant">Manufacturing Plant</option>
                <option value="Warehouse">Warehouse</option>
                <option value="Retail Unit">Retail Unit</option>
                {/* <option value="Single Entity">Single Entity</option> */}
                <option value="Other">Other, please specify</option>
              </select>
              {errors.location_type && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.location_type}
                </p>
              )}
            </div>
            {/* Custom Type (Parallel to Status if visible) */}
            {formData.location_type === "Other" ? (
              <div>
                <label className="text-sm text-[#06513D]">Specify Type</label>
                <input
                  type="text"
                  name="other_type"
                  value={formData.other_type}
                  onChange={handleChange}
                  placeholder="Enter location type"
                  className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none animate-fadeIn"
                />
                {errors.other_type && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.other_type}
                  </p>
                )}
              </div>
            ) : (
              <div className="hidden md:block"></div>
            )}

            {/* Status */}
          </div>

          {/* Buttons */}
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={onClose}
              className="px-6 py-2 border border-[#06513D] text-[#06513D] rounded-md"
            >
              Cancel
            </button>

            <button
              onClick={handleSave}
              className="px-6 py-2 bg-[#06513D] text-white rounded-md"
            >
              Add Details
            </button>
          </div>
        </div>
      </DialogBox>
      {successPopup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type={successPopup.type}
            title={successPopup.title}
            message={successPopup.message}
          />
        </div>
      )}
    </div>
  );
};

export default AddLocation;
